import backgroundEmpty from './bg-empty.svg';
import brokenVector from './broken-vector.png';
import defaultAvatar from './default-avatar.png';
import directionDown from './direction-down.svg';
import arrangeTrial from './howItWorks/arrange-trial.png';
import getMatched from './howItWorks/get-matched.png';
import request from './howItWorks/request.png';
import selectPackages from './howItWorks/select-packages.png';
import sitBack from './howItWorks/sit-back.png';
import statSearching from './howItWorks/start-searching.png';
import authLayout from './layout.svg';
import americanExpress from './payments/american-express.png';
import cardsIcon from './payments/cards.png';
import masterCard from './payments/master-card.png';
import payNowIcon from './payments/paynow.png';
import scanQRcode from './payments/scan.png';
import visaMethod from './payments/visa.png';
import requestCreated from './request-created.png';
import termsPlans from './terms/plans.png';
import termsSurcharges from './terms/surcharges.png';

export const APP_IMG = {
  defaultAvatar,
  authLayout,
  backgroundEmpty,
  payNowIcon,
  cardsIcon,
  americanExpress,
  visaMethod,
  masterCard,
  requestCreated,
  scanQRcode,
  request,
  statSearching,
  getMatched,
  arrangeTrial,
  selectPackages,
  sitBack,
  termsPlans,
  termsSurcharges,
  brokenVector,
  icons: {
    directionDown,
  },
};

export default APP_IMG;
